import React from 'react';
import {Card} from './card';
import assurance from '../../../../../../../assets/images/svg/100-assurance.svg';
import {BankAccountType} from '../../../../../../../constants/models/servicePayloads/bankAccountType';
import {PasService} from './pasService';

export const Assurance = ({branch, isMain, globalPayload, setGlobalPayload, displayComments, disableModifications}) => {
    const cardTypes = [BankAccountType.AssuranceDeces, BankAccountType.AssuranceObseque, BankAccountType.AssuranceVie];

    return (
        <div className="grid grid-md-min grid-lg-tight grid-lg-4">
            {
                cardTypes.map((name, index) => {
                    return <Card key={index} cardType={name} icon={assurance} branch={branch} isMain={isMain}  globalPayload={globalPayload} setGlobalPayload={setGlobalPayload} displayComments={displayComments}  disableModifications={disableModifications}/>
                })
            }
            {/* <PasService icon={assurance} cardType={BankAccountType.PasAssurance}/> */}
        </div>
    );
}